export const UPLOADER_ORIGIN = {
  sites: 'sites',
  reports: 'reports',
};

export const FETCH_DATA_OK_STATUS = [200, 201, 204];
export const FETCH_DATA_ERROR_STATUS = [422];

export const NOT_EMPTY_PROPS = (obj) =>
  Object.fromEntries(Object.entries(obj).filter(([, value]) => value !== undefined));

export const API_CALL_METHODS = {
  api: '$api',
  route: '$route',
};

export const FILE_UPLOADER_DATA = {
  sites: {
    action: {
      deleteFiles: {
        endpoint: 'delete.tool.files',
        params: ({ repository, project, site, uuid }) => ({ repository, project, site, uuid }),
      },

      downloadFiles: {
        endpoint: 'download.tool.files',
        params: ({ repository, project, site, uuid }) => ({ repository, project, site, uuid, version: '1.0' }),
        downloadURLResponse: (res) => res,
        apiCallMethod: API_CALL_METHODS.route,
      },

      listFiles: {
        endpoint: 'get.tool.files',
        params: ({ repository, project, site }) => ({ repository, project, site }),
      },

      uploadFiles: {
        endpoint: 'upload.tool.files',
        params: ({ repository, project, site }) => ({
          repository,
          project,
          site,
        }),
        specificComponentUploadProcess: true,
      },
    },
  },
  reports: {
    action: {
      deleteFiles: {
        endpoint: 'repositories.projects.reports.files.delete',
        params: ({ repository, project, report, reportFile }) => ({
          version: '1.0',
          repository,
          project,
          report,
          reportFile,
        }),
      },

      downloadFiles: {
        endpoint: 'repositories.projects.reports.files.download',
        params: ({ repository, project, report, reportFile }) => ({
          version: '1.0',
          repository,
          project,
          report,
          reportFile,
        }),
        downloadURLResponse: (res) => res.data.data.url,
      },

      listFiles: {
        endpoint: 'repositories.projects.reports.files.get',
        params: ({ repository, project, report, perPage, page }) => ({
          version: '1.0',
          repository,
          project,
          report,
          perPage: perPage || 20,
          page: !perPage ? page || 1 : 1,
        }),
        metaPagination: true,
      },

      uploadFiles: {
        endpoint: 'repositories.projects.reports.files.upload',
        params: ({ repository, project, report, page, files }) => ({
          version: '1.0',
          repository,
          project,
          report,
          page: page,
          files: files,
        }),
        metaPagination: true,
      },
    },
  },
};
